import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router-dom';

// Initialize Sentry only if DSN is configured
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn && !sentryDsn.includes('your-sentry-dsn')) {
  Sentry.init({
    dsn: sentryDsn,
    
    // Tunnel requests through our backend to bypass ad blockers
    // Temporarily disabled for testing - re-enable once tunnel is working
    // tunnel: import.meta.env.DEV ? '/api/sentry-tunnel' : undefined,
    
    // Performance Monitoring
    integrations: [
      // React Router v6 integration for navigation tracking
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      
      // Session Replay for visual reproduction of user sessions
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring
    // In production, you may want to lower this to reduce costs
    tracesSampleRate: 1.0,

    // Set tracePropagationTargets to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^\//,  // Relative URLs
      /^https?:\/\/.*\.fly\.dev\/api/,  // Fly.io deployment
      /^http:\/\/localhost:3001/,  // Local development server
    ],

    // Capture Replay for 10% of all sessions
    replaysSessionSampleRate: 0.1,
    
    // Capture Replay for 100% of sessions with an error
    replaysOnErrorSampleRate: 1.0,

    // Environment tracking
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,

    // Enable sending PII (personally identifiable information) like IP addresses and user IDs
    sendDefaultPii: true,
  });
}

